import { createFileRoute } from "@tanstack/react-router";

import ComingSoonCover from "@/components/ComingSoonCover";

import placeholder from "./-assets/placeholder-alerts.png";

export const Route = createFileRoute("/_staff/devices/_list/alerts")({
  component: () => <ComingSoonCover placeholderImage={placeholder} />,
});
